import { FormantInfo, formantRange, getFormants } from "../phonemes/formants";
import { IpaType } from "../phonemes/ipa";

/** find the closest vowel to 'vowel' from within 'checkVowels' based on formants */
export function closestVowel(vowel: IpaType, checkVowels: IpaType[]): IpaType | null {
  if (checkVowels.includes(vowel)) {
    // if it's in the list, it's trivially the closest vowel
    return vowel;
  }

  // assume we have single vowels rather than diphthongs
  const inputFormant = getFormants(vowel)[0];
  const checkFormants = checkVowels.map(ipa => getFormants(ipa)[0]);

  let closestDistance = Number.MAX_VALUE;
  let bestVowel = null;
  checkFormants.forEach((current, i) => {
    const thisDistance = computeDistance(inputFormant, current);
    if (thisDistance < closestDistance) {
      closestDistance = thisDistance;
      bestVowel = checkVowels[i];
    }
  });

  return bestVowel;
}

/** compute the perceived distance between sounds in formant space */
function computeDistance(a: FormantInfo, b: FormantInfo): number {
  // log based to account for perception,
  // scaled by the ranges while adjusting for the fact that f2 has a larger range
  const f1 = Math.log(Math.abs(a.f1 - b.f1) * 100 / formantRange.f1Max);
  const f2 = Math.log(Math.abs(a.f2 - b.f2) * 200 / formantRange.f2Max);
  return Math.sqrt(f1 * f1 + f2 * f2);
}
